import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";

import { camelToSnakeKeys } from "@/utils/string";

import type HttpMethods from "../enums/HttpMethods";
import Logger from "../logger/Logger";

export const REDIRECT_CODES = [404, 422, 500];

class DeprecatedApiService {
    public baseUrl: string;

    public constructor(private readonly apiUrl: string) {
        this.baseUrl = apiUrl.replace(/\{VERSION\}/, "1");
    }

    public async send<T>(
        url: string,
        method: HttpMethods,
        data?: unknown,
        headers?: Record<string, string>,
        transformToSnakeCase = true,
    ): Promise<T | undefined> {
        try {
            data = transformToSnakeCase ? camelToSnakeKeys(data as Record<string, any>) : data;
            const response = await axios.request<T>(this.createRequest(url, method, data, headers));

            if (this.validateResponse(response)) {
                // TODO
            }
            return response.data as T;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return e.response?.data;
            }
            if (e instanceof Error) {
                Logger.error(e.message);
            }
            Logger.error("Unknown error in ApiService");
            return undefined;
        }
    }

    private createRequest(
        url: string,
        method: HttpMethods,
        data?: unknown,
        headers?: Record<string, string>,
    ): AxiosRequestConfig {
        return {
            url: `${this.baseUrl}/${url}`,
            method,
            data,
            headers: {
                token: localStorage.getItem("token"),
                ...headers,
            },
            responseType: "json",
        };
    }

    private validateResponse<T>(response: AxiosResponse): boolean {
        if (REDIRECT_CODES.includes(response.status)) {
            Logger.error(response.statusText, response.data, response.status);
        }
        return true;
    }
}
export default DeprecatedApiService;
